module.exports = __webpack_public_path__ + "img/dsci0091.55e05167.jpg";